import PropTypes from 'prop-types';
import React from 'react'

import { Icon } from '~/components'

import CampsFeed from './SideBar-Camps'
import InterestsFeed from './SideBar-Interests'


export default class extends React.Component {
	
    static propTypes = {
		selectedFilter: PropTypes.string,
	};

    render() {

		return (

			<div className="left-sidebar">

				<div className="row pbot15-xs pbot15-sm">

					<div className="col-sm-12 col-xs-6 pleft0 pleft15-sm pleft15-xs">

						<CampsFeed selectedCamp={this.props.selectedFilter} />

					</div>

					<div className="col-sm-12 col-xs-6 pleft0 pleft15-sm pleft15-xs mtop20 mtop0-xs">

						<InterestsFeed selectedInterest={this.props.selectedFilter}/>
									
					</div>

				</div>

				<div className="clearfix" />

	        </div>



		)

	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/SideBarLeft/SideBar-Master.jsx